<template>
	<div>
		<button class="btn btn-secondary btn-sm float-right" type="button" v-on:click.prevent="addBien">
			<i class="material-icons">add_circle</i>
		</button>
		<ul class="nav nav-tabs" id="bienesTab" role="tablist">
			<li class="nav-item">
				<a class="nav-link active" id="bienes-tab" data-toggle="tab" href="#bienes" role="tab" aria-controls="bienes" aria-selected="true">Bienes asegurados</a>
			</li>	
		</ul>
		<div class="tab-content" id="bienesTabContent">
			<div class="tab-pane fade show active" id="bienes" role="tabpanel" aria-labelledby="bienes-tab">
				<preloader v-if="loading"></preloader>
				<table class="table table-sm" v-if="bienes.length>0 && !loading">
					<thead>
						<tr>
							<th class="text-left">Bien Asegurado</th>
							<th class="text-center">Suma Asegurada</th>
							<th class="text-center">Deducible 1</th>
							<th class="text-center">Deducible 2</th>
							<th class="text-center">Prima Neta</th>
							<th class="text-center">Prima Total</th>
							<th class="text-center">Observaciones</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in bienes" :class="{'table-danger':errors && errors['bien_asegurado.'+index]}">
							<td>
								<input type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.DESCRIPCION_BIEN">
								<div v-if="errors && errors['bien_asegurado.'+index+'.descripcion']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.descripcion'][0]}}
								</div>
							</td>
							<td>
								<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.SUMA_ASEGURADA" min="0"></decimal>
								<div v-if="errors && errors['bien_asegurado.'+index+'.suma']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.suma'][0]}}
								</div>
							</td>
							<td>
								<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.DEDUCIBLE1" min="0"></decimal>
								<div v-if="errors && errors['bien_asegurado.'+index+'.deducible1']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.deducible1'][0]}}
								</div>
							</td>
							<td>
								<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.DEDUCIBLE2" min="0"></decimal>
								<div v-if="errors && errors['bien_asegurado.'+index+'.deducible2']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.deducible2'][0]}}
								</div>
							</td>
							<td>
								<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.PRIMA_NETA" min="0"></decimal>
								<div v-if="errors && errors['bien_asegurado.'+index+'.primaNeta']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.primaNeta'][0]}}
								</div>
							</td>
							<td>
								<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.PRIMA_TOTAL" min="0"></decimal>
								<div v-if="errors && errors['bien_asegurado.'+index+'.primaTotal']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.primaTotal'][0]}}
								</div>
							</td>
							<td>
								<textarea type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.OBSERVACIONES" min="0"></textarea>
								<div v-if="errors && errors['bien_asegurado.'+index+'.observaciones']" class="text-danger">
									{{errors['bien_asegurado.'+index+'.observaciones'][0]}}
								</div>
							</td>
							<td width="50px">
								<button type="button" v-on:click="deleteBien(index)" class="btn btn-sm btn-danger" v-if="roleUser() != 'V'">
								<i class="material-icons">delete</i>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<div v-else class="text-center text-muted py-3">
					No se ha agregado ningún Bien Asegurado.
				</div>	
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['endoso'],

		data(){
			return {
				bienes: [],
				bien: '',
				errors: [],
				loading: false,
			}
		},

		mounted() {
			this.getBienes()

			var vm = this;
			$.fn.getBienesDetalle = function () {
				vm.getBienes();
			};
		},

		methods: {
			getBienes: function(){
				this.loading = true
				axios.get('api/endosos/'+this.endosoId+'/bienes')
				.then(response=>{
					console.log(response.data)
					this.bienes = response.data
				}).catch(error=>{
					console.log(error.response)
				}).then(() => {
					this.loading = false
				})
			},
			
			addBien: function(){
				/*axios.post('api/bienes/'+this.endosoId, {
					descripcion: this.bien
				})
				.then(response=>{
					this.getBienes()
					this.bien = ''
					this.bienes = []
					this.$toasted.show('El Bien ha sido Agregado.');
				}).catch(error=>{
					this.$toasted.show('Error al Agregar Bien.');
					if (error.response.status === 422) {
			        	this.errors = error.response.data.errors || {};
			        }
					console.log(error.response)
				})*/

				this.bienes.push({
					DESCRIPCION_BIEN: '',
					SUMA_ASEGURADA: '',
					DEDUCIBLE1: '',
					DEDUCIBLE2: '',
					PRIMA_NETA: '',
					PRIMA_TOTAL: '',
					OBSERVACIONES: ''
				})
			},

			deleteBien: function(id){
				/*axios.delete('api/bienes/'+id+'/delete')
				.then(response=>{
					this.getBienes()
					this.$toasted.show('El Bien ha sido Eliminado.');
				}).catch(error=>{
					this.$toasted.show('Error al eliminar Bien.');
					console.log(error.response)
				})*/
				this.bienes.splice(id, 1)
				this.errors = {}
			}
		},

		computed: {
			endosoId: function(){
				return this.endoso
			}
		},

		watch: {
			endosoId: function(val){
				this.getBienes();
			}
		}
	}
</script>